var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-content"},[_c('div',{staticClass:"copy-url"},[_vm._v(_vm._s(_vm.address))]),_vm._v(" "),_c('div',{class:['copy-btn', _vm.hasCopy&&'has-copy'],on:{"click":_vm.copyAddress}},[_vm._v(_vm._s(_vm.hasCopy?'已复制':'复制链接'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f744da2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav/exportDialog/dialogSharePart.vue
// module id = null
// module chunks = 